import React from "react";
import { motion } from "framer-motion";

export default function V2PageHero({ eyebrow, title, highlight, copy, image }) {
  return (
    <section
      data-testid="v2-page-hero"
      className="relative isolate bg-[#001A4D] text-white pt-28 pb-10 md:pt-32 md:pb-14 overflow-hidden"
    >
      {image && (
        <>
          <motion.div
            initial={{ scale: 1.06, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ duration: 1.3, ease: [0.16, 1, 0.3, 1] }}
            className="absolute inset-0 -z-20"
          >
            <img src={image} alt="" className="w-full h-full object-cover opacity-50" />
          </motion.div>
          <div className="absolute inset-0 -z-10 bg-gradient-to-b from-[#001A4D]/80 via-[#002366]/85 to-[#001A4D]" />
        </>
      )}

      <div className="container-x relative">
        <motion.p
          initial={{ opacity: 0, y: 14 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="overline text-[#6B8AFF]"
        >
          {eyebrow}
        </motion.p>
        <div className="gold-rule mt-5 mb-6" />
        <motion.h1
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.05 }}
          className="font-heading font-light tracking-tight text-3xl sm:text-4xl lg:text-5xl leading-[1.08] max-w-4xl"
        >
          {title}{" "}
          {highlight && (
            <span className="font-black text-[#6B8AFF]">{highlight}</span>
          )}
        </motion.h1>
        {copy && (
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.15 }}
            className="mt-6 text-slate-300/85 text-sm md:text-base leading-relaxed max-w-2xl"
          >
            {copy}
          </motion.p>
        )}
      </div>
    </section>
  );
}
